import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { MeState, MeProfile, ApiResponse } from "models";

const storedProfile = sessionStorage.getItem("meProfile");
const parsedProfile = storedProfile ? JSON.parse(storedProfile) : null;

const initialState: MeState = {
  loading: false,
  profile: parsedProfile,
  error: null,
  fetched: !!parsedProfile,
};

const meSlice = createSlice({
  name: "me",
  initialState,
  reducers: {
    getMeRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getMeSuccess(state, action: PayloadAction<MeProfile>) {
      state.loading = false;
      state.profile = action.payload;
      state.fetched = true;
      state.error = null;
    },
    getMeFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.fetched = true;
    },
    clearMe(state) {
      state.loading = false;
      state.profile = null;
      state.error = null;
      state.fetched = false;
    },
  },
});

export const meActions = meSlice.actions;

export const selectMeProfile = (state: RootState) => state.me?.profile;
export const selectMeLoading = (state: RootState) => state.me?.loading;
export const selectMeFetched = (state: RootState) => state.me?.fetched;
export const selectMeError = (state: RootState) => state.me?.error;

const meReducer = meSlice.reducer;
export default meReducer;
